// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict, List } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetApiServerTime (params?: {}): Promise<Dict>;
    publicGetApiPairs (params?: {}): Promise<List>;
    publicGetApiPriceIncrements (params?: {}): Promise<Dict>;
    publicGetApiSummaries (params?: {}): Promise<Dict>;
    publicGetApiTickerPair (params?: {}): Promise<Dict>;
    publicGetApiTickerAll (params?: {}): Promise<Dict>;
    publicGetApiTradesPair (params?: {}): Promise<List>;
    publicGetApiDepthPair (params?: {}): Promise<Dict>;
    publicGetTradingviewHistoryV2 (params?: {}): Promise<List>;
    privatePostGetInfo (params?: {}): Promise<Dict>;
    privatePostTransHistory (params?: {}): Promise<Dict>;
    privatePostTrade (params?: {}): Promise<Dict>;
    privatePostTradeHistory (params?: {}): Promise<Dict>;
    privatePostOpenOrders (params?: {}): Promise<Dict>;
    privatePostOrderHistory (params?: {}): Promise<Dict>;
    privatePostGetOrder (params?: {}): Promise<Dict>;
    privatePostGetOrderByClientOrderId (params?: {}): Promise<Dict>;
    privatePostCancelOrder (params?: {}): Promise<Dict>;
    privatePostCancelByClientOrderId (params?: {}): Promise<Dict>;
    privatePostWithdrawFee (params?: {}): Promise<Dict>;
    privatePostWithdrawCoin (params?: {}): Promise<Dict>;
    privatePostListDownline (params?: {}): Promise<Dict>;
    privatePostCheckDownline (params?: {}): Promise<Dict>;
    privatePostCreateVoucher (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
